/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeType } from './CodeType';
import {
    CodeTypeFromJSON,
    CodeTypeFromJSONTyped,
    CodeTypeToJSON,
    CodeTypeToJSONTyped,
} from './CodeType';

/**
 * A code as a list row: the program text cut to a preview, without the Blockly workspace
 * and the teacher comments. `GET /codes/{code_id}` returns the whole code.
 * @export
 * @interface CodeListItem
 */
export interface CodeListItem {
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    name: string;
    /**
     * 
     * @type {CodeType}
     * @memberof CodeListItem
     */
    type: CodeType;
    /**
     * The first 200 characters of the program
     * @type {string}
     * @memberof CodeListItem
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    problem_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof CodeListItem
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof CodeListItem
     */
    last_used: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CodeListItem
     */
    is_active: boolean;
}



/**
 * Check if a given object implements the CodeListItem interface.
 */
export function instanceOfCodeListItem(value: object): value is CodeListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('last_used' in value) || value['last_used'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    return true;
}

export function CodeListItemFromJSON(json: any): CodeListItem {
    return CodeListItemFromJSONTyped(json, false);
}

export function CodeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': CodeTypeFromJSON(json['type']),
        'code': json['code'],
        'problem_id': json['problem_id'] == null ? undefined : json['problem_id'],
        'user_id': json['user_id'],
        'created_at': (new Date(json['created_at'])),
        'last_used': (new Date(json['last_used'])),
        'is_active': json['is_active'],
    };
}

export function CodeListItemToJSON(json: any): CodeListItem {
    return CodeListItemToJSONTyped(json, false);
}

export function CodeListItemToJSONTyped(value?: CodeListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': CodeTypeToJSON(value['type']),
        'code': value['code'],
        'problem_id': value['problem_id'],
        'user_id': value['user_id'],
        'created_at': ((value['created_at']).toISOString()),
        'last_used': ((value['last_used']).toISOString()),
        'is_active': value['is_active'],
    };
}

